import styled from 'styled-components';
import { withRouter } from 'next/router';
import { bool, object, func, string, shape } from 'prop-types';
import { Component } from 'react';

import Logo from './Logo';
import Menu from '../Menu';
import SearchField from './SearchField';
import { WHITE_COLOR, TABLET_SIZE, LAPTOP_SIZE } from '../../constants';

const headerShadow = '0px 3px 12px 1.2px rgba(0, 0, 0, 0.1)';

const Container = styled.header`
  align-items: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : WHITE_COLOR};
  box-shadow: ${({ backgroundColor }) =>
    backgroundColor === WHITE_COLOR ? headerShadow : 'none'};
  display: flex;
  height: 128px;
  padding: 0px 30px;
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  transition: background-color 150ms linear;
  z-index: 1;

  .bm-burger-button {
    display: none;
  }
  @media (max-width: ${TABLET_SIZE}) {
    padding-left: 15px;
  }
  @media (max-width: ${LAPTOP_SIZE}) {
    .bm-burger-button {
      display: block;
    }
  }
`;

class Header extends Component {
  render() {
    const { backgroundColor, fontColor } = this.props.headerColor;
    const {
      updateQuery,
      updateSearch,
      showSearchBar,
      router,
      updateI18lCategoryList,
      resetState,
    } = this.props;

    return (
      <Container backgroundColor={backgroundColor}>
        <Logo fontColor={fontColor} onClick={resetState} />
        {showSearchBar && (
          <SearchField
            fontColor={fontColor}
            updateQuery={updateQuery}
            updateSearch={updateSearch}
          />
        )}
        <Menu
          pathname={router.pathname}
          fontColor={fontColor}
          updateI18lCategoryList={updateI18lCategoryList}
        />
      </Container>
    );
  }
}

Header.propTypes = {
  headerColor: shape({
    backgroundColor: string.isRequired,
    fontColor: string.isRequired,
  }).isRequired,
  updateQuery: func,
  updateSearch: func,
  showSearchBar: bool.isRequired,
  isTransparent: bool,
  router: object,
  updateI18lCategoryList: func,
  resetState: func,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// components/Header/index.js